{
  "shield-tally": {
    "templateId": "unpaid-shield",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "Twelve in escrow. I can stop counting for a minute. Only a minute."
      },
      {
        "id": "place",
        "beatId": "beat:reeves-court",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "That clerk charges for the wax as well as the stamp. My sister pays for both. Count the seals before you agree."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "towpath-scout",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "{other}, if anyone asks who showed us the way, tell them you came to carry a bag. One bag. No names."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I keep counting the party and coming up one short. You would think the numbers would learn by now."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Another outsider. I keep a column for you all now. The boat keeps the clerk in wax."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Nothing moving on the lift at all. I have run out of things to count. I do not like it."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "One guard fewer on the books. I count him all the same. Somebody should."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "Back from the books of the dead, and walking. I will not tick that column twice."
      }
    ]
  },
  "shield-sergeant": {
    "templateId": "unpaid-shield",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "We can talk while we walk. Anyone tells you otherwise has never marched anywhere."
      },
      {
        "id": "place",
        "beatId": "beat:reeves-court",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "A dry chair and two guards. Every officer I ever served wanted those before they wanted a road repaired."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "displaced-mason",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "{other} checks the stone before putting weight on it. I wish they had taught officers that."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "A column notices a gap before it notices anything else. We walk on. That is the job."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I have marched beside an outsider before. They marched like merchants for a week. You will learn."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "Every winch still. I have seen camps like that. It means the orders stopped making sense."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "He chose his post and you chose your steel. I have buried worse for less. Keep your edge clean."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "A survivor in the line again. I have seen few. Treat them as the lesson, not the luck."
      }
    ]
  },
  "shield-eager": {
    "templateId": "unpaid-shield",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "Right. Hired. I should look more solemn, probably. My brother would be laughing at me."
      },
      {
        "id": "place",
        "beatId": "z04-cart-ramp-office",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "My brother pushes carts like those. I used to tell him it was easier than soldiering. I owe him an apology."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "former-mortuary-guard",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "{other}, if you need help carrying someone home, ask. My brother taught me to lift from the knees. About all he taught me that stuck."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "My brother would have a joke for this. I do not. Not yet."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "My brother says outsiders all come back changed. I said they do not come back at all. He just smiled."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "It is too quiet. My brother pushes carts off that lift. What does he do when it does not move?"
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "So that is what it looks like up close. I thought I would feel braver. Do not tell my brother."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "They lived through it? Then it can be lived through. Say that again, slowly."
      }
    ]
  },
  "shield-silent": {
    "templateId": "unpaid-shield",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I heard the terms. Let us go."
      },
      {
        "id": "place",
        "beatId": "beat:reeves-court",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "That is where the bond sits. In a drawer. My daughter sleeps in a shed."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "displaced-mason",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "{other} knows where the roof will fall. I stand where they stand."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "I said the name. Let us go."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "You are not the first. I remember the others."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "Still. All of it. My daughter sleeps under a silent wheel."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "A man down. Mine to carry now, not only yours."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Alive. Of all things. I was ready to carry a name and now I carry nothing."
      }
    ]
  },
  "shield-camp": {
    "templateId": "unpaid-shield",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "We used to say a job began with sharing water. Here. There is enough."
      },
      {
        "id": "place",
        "beatId": "beat:lift-yard",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "We used to warm bread beside a winch like that. My son always took the burnt piece. Said he liked it. We knew better."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "displaced-mason",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "{other}, come eat with us when we stop. A person who keeps the roof up should get the dry seat."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "We shared water with them. That does not stop because they are not here to drink."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "The last outsider took the burnt piece as well. Sit. There is enough."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "No winch to warm bread beside. We will manage. We always manage. That is the trouble."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "Somebody will set a place for him tonight and it will stay empty. Sit with that a while."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "Somebody kept the fire for them, I think. Let them sit nearest it."
      }
    ]
  },
  "scout-still": {
    "templateId": "towpath-scout",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Wait. Let that cart pass. I like to hear who is walking behind us."
      },
      {
        "id": "place",
        "beatId": "beat:eastern-road-lock-foot",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Listen below the lock. You can hear the water through the stones. Walk softly here; sound carries both ways."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "unpaid-shield",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "{other}, wrap that buckle before the narrow path. I know you can fight. I would rather no one heard us coming."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Listen. One set of footsteps fewer. I hear it every time we stop."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The last outsider drowned their footsteps the same way. You walk quieter. Keep it that way."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Listen. No cables, no water through the stones. I have never heard this place hold its breath."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The guard post is quiet now. Quiet is only good when you chose it."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "They know the way out better than I do. I would listen to the one who came back."
      }
    ]
  },
  "scout-patter": {
    "templateId": "towpath-scout",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "Contract settled. Complaints cost extra. That was a joke; do not reach for your purse."
      },
      {
        "id": "place",
        "beatId": "beat:eastern-road-lock-foot",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Lovely view, the lock. Costs nothing to look. What is underneath it is not for sale."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "displaced-mason",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "{other} looks at a wall and sees wages. I look at it and see a way round. Between us we might make a living."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "No joke this time. They earned better than a joke."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Another one off the boat! The boat never learns. No offence; you seem nicer than the last."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The view is free and now so is the lift. Nothing moves, nobody pays, everybody loses."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "One uniform gone and the fee does not change. Funny how death never moves the price."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "A survivor, and for free. First thing all week that cost nothing."
      }
    ]
  },
  "scout-drain": {
    "templateId": "towpath-scout",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Could we move away from the open part? I can hear you just as well by the wall."
      },
      {
        "id": "place",
        "beatId": "beat:eastern-road-lock-foot",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "That grate. I could fit through it once. Please do not stand there looking down. Someone will notice."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "unpaid-shield",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "{other}, stay on the road side of me. Just until we pass the watch. You do not have to say anything."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I keep looking over my shoulder for them. Old habit. I am not sorry for it."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The last outsider stood in the open as well. By the wall, please. Same reason as before."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "When the works stop, the watch starts walking. Can we not stand here in the open?"
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Someone will come looking for that guard. Can we be elsewhere when they do?"
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Whatever hunted them might still be hunting. Keep them between us."
      }
    ]
  },
  "mason-pier": {
    "templateId": "displaced-mason",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "Good. Work, then. My youngest asked whether I had built anything today. I would like a better answer tonight."
      },
      {
        "id": "place",
        "beatId": "beat:lift-yard",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "story:grain-settled"
          ]
        },
        "expression": "listening",
        "text": "Look at the wear on that bearing. Four children could eat for a month on what they saved by not replacing it. Mine, for instance."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "former-mortuary-guard",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "{other}, when you have the names, bring them to me. I can cut letters. Stone keeps them longer than a board."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "My youngest will ask who I built things with this week. I will give them the name."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "I cut a name for the last outsider. I would rather not cut yours. Watch the bearings."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "Every bearing in the place, still. I built some of that. Do not ask me to smile about it."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "You can lay a course badly and rebuild. You cannot rebuild him. Remember that."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "What stands after a collapse is worth more than what never fell. Mind them."
      }
    ]
  },
  "mason-plumb": {
    "templateId": "displaced-mason",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "Thank you. I mean, for reading the terms. People usually skip the bit about the walls."
      },
      {
        "id": "place",
        "beatId": "beat:lift-yard",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "story:grain-settled"
          ]
        },
        "expression": "listening",
        "text": "The lift is pulling to one side. Sorry, I cannot walk past that without looking. My aunt says I do it with table legs too."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "unpaid-shield",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "{other}, that strap is taking the weight at one point. May I see it when we stop? My mother taught me a better stitch."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The terms said the walls might fall. Nobody writes down the bit about the people. Read carefully."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "The last outsider read the terms before signing, like you. That is not a small thing, where I come from."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Nothing pulling, nothing straining. A structure at rest should comfort me. This does not."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "A guard struck down is a load removed that cannot be put back. I distrust that kind of work."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "They carry the old fault lines in how they walk. I would ask before I trusted a floor."
      }
    ]
  },
  "mason-crew": {
    "templateId": "displaced-mason",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "We have an agreement. The crew used to shake on those. No clerk ever improved one."
      },
      {
        "id": "place",
        "beatId": "beat:lift-yard",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "A bearing costs less than a crew. Somehow they always find money for the crew after the bearing gives out."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "former-mortuary-guard",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "{other}, you keep the names of the dead. Good. The quarry calls ours a lost shift. I have never met a shift with a widow."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "The crew does not call it a lost shift. We say the name."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The crew still talks about the last outsider. Shake on the terms and they will talk about you."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The whole works stopped and no crew called. That is how you know the money left first."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "The crew will hear of it by dusk. Nothing travels faster than a dead guard."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "One of the last crew home. The rest will want to hear it from them."
      }
    ]
  },
  "guard-vigil": {
    "templateId": "former-mortuary-guard",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Before we go. If I stop to say a name, let me finish. It does not take long."
      },
      {
        "id": "place",
        "beatId": "z04-gate-of-accounts",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "They count carts at this gate. At mine, we counted names. I would like to know when those stopped being the same number."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "displaced-mason",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "{other}, tell me the names of your crew when we rest. There is room for them in the watch."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "One more name for the watch. I will say it when we stop."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The last outsider's name is in the watch. Yours stays out of it while you are breathing."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "When the wheels stop, the names keep coming. Count the carts another day."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "I will say his name once, quietly. You need not stay for it."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "I keep watch for the dead. It is strange to stand beside one the watch gave back."
      }
    ]
  },
  "guard-carts": {
    "templateId": "former-mortuary-guard",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I know this road too well. If I go quiet, it is not because I have nothing to say."
      },
      {
        "id": "place",
        "beatId": "z04-cart-ramp-office",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I used to wait by that ramp for my wage. Never once asked what was coming back down. I remember exactly where I stood."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "unpaid-shield",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "{other}, I hear you sending your wage home. Keep doing that. Mine used to disappear before I had to think about earning it."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I went quiet back there. You know why."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I was by the ramp when the last outsider's wage came down. I remember where I stood that day as well."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I stood by that ramp when it moved. I remember exactly where I stood. It is not moving."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I knew men on that post. I will not ask which one it was. Not yet."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "They came through a post worse than mine. I will not ask what it cost."
      }
    ]
  },
  "guard-gallows": {
    "templateId": "former-mortuary-guard",
    "remarks": [
      {
        "id": "setting-out",
        "beatId": "beat:middle-market-cold-bath",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "A wage, a road, and someone still breathing beside me. A promising start by my standards."
      },
      {
        "id": "place",
        "beatId": "z04-gate-of-accounts",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "A gate for counting things in and none for counting them out. Very efficient. Saves the clerk half the work and everyone else a conscience."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "displaced-mason",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "{other}, I may want a stone cut one day. Small one. If anyone wants a grand speech, charge them extra."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "Someone still breathing beside me. Fewer than yesterday. Walk on, road."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Another outsider! The river must be running a discount. The last one paid full price."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Nothing to count in, nothing to count out. The clerk must be thrilled. Half the work, a whole conscience."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "One of us, once. Do not make a habit of it, or I shall have to count my own chances."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Another who cheated the gallows. We should compare notes, quietly."
      }
    ]
  },
  "shield-bridge": {
    "templateId": "unpaid-shield",
    "remarks": [
      {
        "id": "place",
        "beatId": "beat:z01-grain-court",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Same queue, every morning. My sister knows the order by heart. The clerk still asks her name."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "displaced-mason",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "{other}, you know what a bridge costs to build. I know what it costs to watch one for four months unpaid. We should compare accounts."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "My sister will ask who is missing from the queue. I will have an answer for her."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "My sister will ask whether you knew the last outsider. Everyone asks. The queue remembers."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "No queue this morning. My sister did not know what to do with her hands."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "He stood at that post every morning. My sister knew his face from the queue."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "warm",
        "text": "My sister said the queue always has a few who come back. Here is one."
      }
    ]
  },
  "guard-mole": {
    "templateId": "former-mortuary-guard",
    "remarks": [
      {
        "id": "place",
        "beatId": "beat:z02-mole-berths",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Look at the tide mark on that step. That is where we lay them when the water brings them in. Nobody puts a price there."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "former-mortuary-guard",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "{other}, you keep a watch too. Stay with me when we carry them up. It helps to have someone who knows to be quiet."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "I have carried them up from the water before. It does not get lighter."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The water brought the last outsider in, same as you. I said the name. I will learn yours."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The water still brings them in, works or no works. The tide does not stop for a broken wheel."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "The water will take him back eventually. Everyone ends in the tide here."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "The tide let this one go. It rarely does. Do not give it cause to change its mind."
      }
    ]
  },
  "mason-hoist": {
    "templateId": "displaced-mason",
    "remarks": [
      {
        "id": "place",
        "beatId": "beat:z06-broken-span",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": [
            "z06:arch-closed"
          ]
        },
        "expression": "listening",
        "text": "Count the courses that stop halfway across. We laid every one. Six mouths in the huts, and the lease pays better for a broken bridge."
      },
      {
        "id": "company",
        "beatId": null,
        "otherTemplate": "unpaid-shield",
        "prerequisites": {
          "all": [],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "{other}, do not brace against that parapet. I set it. I know which lime they made us use."
      },
      {
        "id": "loss",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:companions-fallen"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "We laid courses together. I will not say which lime we used. It holds."
      },
      {
        "id": "another-outsider",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:later-life"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Six mouths in the huts remember the last outsider's coin. Outsiders spend. The lease does not."
      },
      {
        "id": "still-works",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:work-stopped"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "We laid every course and the lease still pays better for it broken. Count the still courses now."
      },
      {
        "id": "guard-down",
        "beatId": null,
        "prerequisites": {
          "all": [
            "world:guard-dead"
          ],
          "any": [],
          "none": []
        },
        "expression": "listening",
        "text": "Another gap in the course that nobody can fill. We keep making them."
      },
      {
        "id": "survivor-beside",
        "beatId": null,
        "unlessSurvivor": true,
        "prerequisites": {
          "all": [
            "world:survivor-with-you"
          ],
          "any": [],
          "none": []
        },
        "expression": "firm",
        "text": "A gap that filled itself back in. I did not think a course could do that."
      }
    ]
  }
}
